import Vue from 'vue'
import FeatherIcon from '../../components/feather-icon/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
